<template>
    <div class="displayPage">
        <leftTree ref="treeLeft" @changeWay="changeWayFn" />

        <div class="rightPage" style="width:calc(100% - 300px)">
            <div class="w-100 h-100">
                <div class="device-status-desc">{{ $t(deviceStatusButton[sensorWay].title) }}</div>
                <components :selectDeviceType="selectDeviceType" style="height: calc(100% - 50px);" :is="sensorWay"
                    :sensorWay="sensorWay" ref="componentContent" :deviceDisplayType="deviceDisplayType"></components>
            </div>
        </div>
        <i class="iconfont icon-excel question excel" :title="$t('integration.export_template')"
            v-show="sensorWay === 'unknown'" @click="loadFileFn"></i>
        <IconDesc class="question" :iconDesc="displayIconDesc"></IconDesc>

    </div>
</template>

<script>
// import leftTree from './components/LeftTree.vue';
import leftTree from '../gateway/components/leftTree.vue'
import bind from './bind/bindPage.vue'
import unbind from './unbind/unBindPage.vue'
import stop from './stop/stopPage.vue'
import unknown from './unknown/unKnown.vue'
import { getGeneraUploadTemplateFile } from '@/api/modules/deviceUrl.js'
import pleaseSelect from '@/common/pleaseSelect'
import IconDesc from '@/components/IconDesc/IconDesc.vue'
import displayIconDesc from './config/displayIconDesc'
import { deviceStatusButton, deviceTypeListConvert } from '@/utils/convert'
import bus from '@/utils/bus.js'
import { getPermission } from '@/utils/permission'
import { ENUM_DEVICE_WAY } from '@/common/enum/forward/device'

export default {
  components: {
    leftTree,
    bind,
    unbind,
    stop,
    unknown,
    IconDesc
  },
  computed: {
    deviceStatusButton: () => deviceStatusButton,
    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin () {
      return getPermission()
    },
    displayIconDesc: () => displayIconDesc
  },
  data () {
    return {
      sensorWay: ENUM_DEVICE_WAY.BIND,

      deviceDisplayType: [],
      selectDeviceType: []
    }
  },
  created () {
    this.getInitDeviceData()
  },
  methods: {
    getInitDeviceData () {
      this.$store.dispatch('device/getDisplayType').then(res => {
        // 在这里重新把label字段国际化一下吧，本来应该在utils/matchDeviceType文件国际化更好，但是报错，不知道怎么做
        res.forEach(item => {
          item.label = deviceTypeListConvert[item.code]
        })
        this.deviceDisplayType = res
        this.selectDeviceType = [pleaseSelect, ...res]
      })
    },
    loadFileFn () {
      getGeneraUploadTemplateFile('display', this.$i18n.locale).then(res => { })
    },
    changeWayFn (item) {
      this.$refs.treeLeft.filterText = null
      const { way } = item
      this.sensorWay = way
      // 重置左侧树形搜索条件
      if (way === ENUM_DEVICE_WAY.UNBIND || way === ENUM_DEVICE_WAY.UNCONFIRM) {
        this.$refs.componentContent.SearchForm.scopeName = this.$store.getters.SchemaTree[0].label
      } else {
        this.$refs.componentContent.SearchForm.scopeName = null
        this.$refs.componentContent.SearchForm.sceneId = null
      }

      //  this.$refs.componentContent.getListFn();
      /** 抛出一个方法修改树形结构数据 醉了 */
      bus.$emit('editTree', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.displayPage {
    height: 100%;
    display: flex;
    position: relative;

    .rightDropdown {
        position: absolute;
        right: 15px;
        top: 0px;
    }

    .question {
        position: absolute;
        height: 20px;
        right: 15px;
        top: 67px;
        font-size: 18px;
        cursor: pointer;
        color: #9bccfd;

        &:hover {
            color: var(--primary-color);
        }
    }

    .excel {
        right: 40px;
    }

    .rightPage {
        flex: 1;
        height: 100%;
        //padding: 0 15px;
        //border-left: 1px solid #ccc;
        box-sizing: border-box;
    }
}
</style>
